// Lib
import { createReducer } from '@reduxjs/toolkit';

// Actions
import {
  SetSharedKitsSettings,
  SetSharedKits,
  SetSharedKitDetails,
  ClearSharedKitDetails,
  SetSharedKitActionError,
  CleanSharedKitActionError,
  SetSharedKitProducts,
  SetSharedKitMessages,
} from '../actions/sharedKits';
import { UserLogOut } from '../actions/user';

export const initialState = {
  data: null,
  currentKit: null,
  settings: null,
  messages: null,
  actionError: '',
};

export default createReducer(initialState, {
  [SetSharedKitsSettings]: (state, { payload }) => ({
    ...state,
    settings: payload,
  }),
  [SetSharedKits]: (state, { payload }) => ({ ...state, data: payload }),
  [SetSharedKitDetails]: (state, { payload }) => ({
    ...state,
    currentKit: payload,
  }),
  [ClearSharedKitDetails]: (state) => ({
    ...state,
    currentKit: initialState.currentKit,
  }),
  [SetSharedKitMessages]: (state, { payload }) => ({
    ...state,
    messages: payload,
  }),
  [SetSharedKitProducts]: (state, { payload }) => ({
    ...state,
    currentKit: state.currentKit
      ? { ...state.currentKit, products: payload }
      : state.currentKit,
  }),
  [SetSharedKitActionError]: (state, { payload }) => ({
    ...state,
    actionError: payload,
  }),
  [CleanSharedKitActionError]: (state) => ({
    ...state,
    actionError: initialState.actionError,
  }),
  [UserLogOut]: () => initialState,
});
